import { TFunction } from 'react-i18next';

const safeT = (t: TFunction, key?: string, defaultValue?: string, fallback = '') => {
  if (!key) return fallback;
  const translationValue = t(key, defaultValue);
  return translationValue || defaultValue || fallback;
};

/**
 * When i18next has no translation it returns the key unchanged. Use this to show fallback (e.g. API name) instead.
 */
export const translatedOrFallback = (
  translate: (key: string) => string,
  translationKey: string | undefined,
  fallback: string | undefined,
): string => {
  if (!translationKey) return fallback ?? '-';
  const out = translate(translationKey);
  if (out && out !== translationKey) return out;
  return fallback ?? '-';
};

export default safeT;
